__turbopack_context__.v({
  "icon": "styles-module-scss-module__-CEedW__icon",
  "image": "styles-module-scss-module__-CEedW__image",
  "imageContainer": "styles-module-scss-module__-CEedW__imageContainer",
  "isDarkMode": "styles-module-scss-module__-CEedW__isDarkMode",
  "loadingImg": "styles-module-scss-module__-CEedW__loadingImg",
  "lock": "styles-module-scss-module__-CEedW__lock",
  "picture": "styles-module-scss-module__-CEedW__picture",
  "placeholder": "styles-module-scss-module__-CEedW__placeholder",
  "root": "styles-module-scss-module__-CEedW__root",
  "rootVisible": "styles-module-scss-module__-CEedW__rootVisible",
  "title": "styles-module-scss-module__-CEedW__title",
});
